// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"323":"3786506e","639":"95e0fdbe","742":"751b6c89"}[chunkId] + ".js";
};